module.exports = __webpack_public_path__ + "static/media/Program21.3c0b3b2c.jpg";